export default __webpack_public_path__ + "c965d9bcf9f86a60fdd0007b4e5fb369.glb";